module.exports = __webpack_public_path__ + "static/media/measuring-tape-white.328acc32.svg";